import * as React from "react"
import { cn } from "../../lib/utils"

// Squelette de chargement : la forme de ce qui arrive, à la place d'un
// spinner centré. L'œil sait où regarder avant que les données n'arrivent,
// et la page ne saute pas quand elles arrivent.
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn("animate-pulse rounded-md bg-white/[0.06] motion-reduce:animate-none", className)}
      {...props}
    />
  )
}

export { Skeleton }
